import React from 'react'
import {Flex, Hint, TextInput} from '/app/src/component'
import style from './style.css'
import Normal from './Normal'

import MetaFileMessage from './_MetaFileMessage'
import MetaAutoresponse from './_MetaAutoresponse'
import ExchangeData from './_ExchangeData'

export default class MetaMessage extends React.Component {
    render() {
        const type = this.props.entry.meta.type;
        const meta = this.props.entry.meta;
        let message = 'This should be a meta message';
        let agentName = 'This should be a name';
        switch(type) {
                case 'ticket_resolved':
                    //TODO: seen only by employee
                    agentName = meta.details.user_name;
                    message = 'Ärendet arkiverades av ' + agentName;
                    break;
                case 'ticket_transferred':
                    const fromName = meta.details.from_name;
                    const toName = meta.details.to_name;
                    message = fromName + ' har överfört ärendet till ' + toName;
                    break;
                case 'ticket_assigned':
                    agentName = meta.details.user_name;
                    message = 'Ärendet hanteras nu av ' + agentName;
                    break;
                case 'file':
                    message = <MetaFileMessage meta={meta}/>
                    break;
                case 'autoresponse':
                    return <MetaAutoresponse entry={this.props.entry}/>
                case 'offline_message':
                    const formData = meta.details.forms;
                    const entry = this.props.entry;
                    return this.renderFormularMessage(formData, type, entry);
                case 'online_formular':
                    return this.renderOnlineFormularMessage(meta.details.forms, type, this.props.entry);
                default:
                    console.log('Need case for this', this.props.entry);
                    return ''
            }

            return(
                <Flex className={style.meta} hAlignContent='center' m='15px 30px'>
                    <Flex className={style.metaContent}>
                            {message}
                    </Flex>
                </Flex>
            );
    }

    //@TODO
    renderFormularMessage(formData, type, entry){
        let message = 'Besökaren har skickat meddelandet via offline-formulär.'

        return(
            <Flex column w='100%'>
                <Flex hAlignContent='center'>
                    <Flex center bg='#f0f0f0' basis='370px' minh='62px' borderRadius='20px' padding='10px' margin='25px 10px' shrink position='relative'>
                        <Hint style={{position:'absolute', top:'5px', right:'5px', zIndex: '1'}} position='top-end' tooltip='Kolla om personen fortfarande är online. Annars välj "Skicka som e-mail" i högerpanelen efter du svarat i chatten eller kopiera mailadressen och återkoppla via e-mail manuellt.'/>
                        <Flex vAlignContent='center' fontSize='14px' column color='black'>
                            <Flex padding='5px'>
                                {message}
                            </Flex>
                            <ExchangeData entry={entry}/>
                            {this._renderFormularField(formData, entry)}
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
        )
    }

    renderOnlineFormularMessage(formData, type, entry){
        let message = 'Besökaren har fyllt i sina uppgifter via formulär.'

        return(
            <Flex column w='100%'>
                <Flex hAlignContent='center'>
                    <Flex center bg='#f0f0f0' basis='370px' minh='62px' borderRadius='20px' padding='10px' margin='25px 10px' shrink position='relative'>
                        <Hint style={{position:'absolute', top:'5px', right:'5px', zIndex: '1'}} position='top-end' tooltip='Kolla om personen fortfarande är online. Annars välj "Skicka som e-mail" i högerpanelen efter du svarat i chatten eller kopiera mailadressen och återkoppla via e-mail manuellt.'/>
                        <Flex vAlignContent='center' fontSize='14px' column color='black'>
                            <Flex padding='5px'>
                                {message}
                            </Flex>
                            <ExchangeData entry={entry}/>
                            {this._renderFormularField(formData, entry, false)}
                        </Flex>
                    </Flex>
                </Flex>
                <Normal key={'confirmed-0'} entry={entry}
                                           direction='left' position='single'
                                           name={this.props.name} image={this.props.image}
                 />
            </Flex>
        )
    }


    _renderFormularField(formData, entry, body=true){
        if(!formData) return null

        const labels = ['Namn:', 'Email:', 'Tel:', 'Ref:' ]
        const forms = [formData.name, formData.email, formData.phone, formData.customer_ref];
        let fields = forms.map((form, id) => {

            if(form){
                return(
                    <Flex key={id} vAlignContent='center' my='3px'>
                        <Flex shrink={0} width='50px' color='grey'>{labels[id]}</Flex>
                        <Flex width='100%' column grow>
                            <TextInput placeholder='offline_form' disabled value={form} name='displayName' backgroundColor='LightGray1'/>
                        </Flex>
                    </Flex>
                )
            }else{
                return null;
            }
        })

        return(
        <Flex column w='95%' paddingLeft='6px' backgroundColor='#f1f1f1'>
            {fields}
            {body &&
                <Flex marginTop='10px' width='100%' column shrink={0} backgroundColor='#f1f1f1'>
                    <textarea className={style.TextArea}
                        name='note'
                        value={entry.entry_body}
                        rows={5}
                        disabled
                    />
                </Flex>
            }
        </Flex>

        )
    }
}



// WEBPACK FOOTER //
// ./src/component/Conversation/Message/Meta.js